import React from "react";
import styled from "styled-components";
import { FontWeight, content, dominant } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Loading from "@ui-kit/loading";
import ClauseLabelsVerticalRecap from "@radarly/components/clause/labels/vertical-recap";
import { tr } from "@radarly/i18n";
import { ClauseLabels } from "@radarly/models/clause/label";

interface IProps {
  clausesLabels: ClauseLabels[];
  locale: Locale;
  loading: boolean;
  scope: React.ReactNode;
}

const Filters = styled.div`
  margin-top: 16px;
  color: ${content};
`;

const Title = styled.div`
  display: inline-block;
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: ${content};
`;

const InlineList = styled.div`
  display: inline-block;
  width: 100%;
  color: ${dominant};
  font-weight: ${FontWeight.Normal};
  font-size: 14px;
`;

const VerticalRecap = styled(ClauseLabelsVerticalRecap)`
  font-weight: ${FontWeight.Normal};
`;

const RadarlyCardActionScopePopover = ({
  locale,
  clausesLabels,
  scope,
  loading = true,
}: IProps) => {
  return (
    <div>
      <Title>{tr(locale, "CUSTOM_PAGES.WIDGET.COMPUTED_ON")}</Title>
      <InlineList>{scope}</InlineList>
      {clausesLabels.length > 0 && !loading && (
        <Filters>
          <Title>{tr(locale, "CUSTOM_PAGES.WIDGET.FILTERS_APPLIED")}</Title>
          <VerticalRecap
            clausesLabels={clausesLabels}
            colorized
            locale={locale}
          />
        </Filters>
      )}
      {!!loading && <Loading isVisible cover={false} />}
    </div>
  );
};

export default RadarlyCardActionScopePopover;
